export default {
  titles: {
    pickup: 'Afhalen',
    delivery: 'Bezorging',
  },
  buttons: {
    confirm: 'Bevestigen',
  },
};
